import { Link } from "react-router-dom";
import { BsFacebook, BsInstagram } from "react-icons/bs";
import { IoCloseSharp } from "react-icons/io5";
import { useSwipeable } from "react-swipeable";
import Logo from "./Logo";
import { useEffect } from "react";

interface SidebarProps {
  isOpen: boolean;
  toggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggle }) => {
  const swipeHandlers = useSwipeable({
    onSwipedRight: () => isOpen && toggle(),
    trackMouse: true,
    preventScrollOnSwipe: true,
  });

  // Disable body scroll when sidebar is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup the style on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          {...swipeHandlers}
          className="fixed inset-0 bg-black bg-opacity-75 z-50"
          onClick={toggle}
        >
          {/* Sidebar Content */}
          <div
            className={`fixed inset-0 bg-white bg-opacity-90 z-50 transition-transform transform ${
              isOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          >
            {/* Close Button */}
            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
              <Logo
                size={100} // Logo size changes based on scroll
                style={{
                  transition: "all 300ms ease-in-out", // Smooth transition for resizing
                }}
              />
              <button
                onClick={toggle}
                className="text-gray-800 hover:text-gray-600 focus:outline-none"
              >
                <IoCloseSharp size={32} />
              </button>
            </div>

            {/* Navigation Links */}
            <div className="flex flex-col space-y-2 mt-6">
              {[
                { path: "/", label: "Hem" },
                { path: "/boka", label: "Boka" },
                { path: "/schema", label: "Schema" },
                { path: "/klasser", label: "Klasser" },
                { path: "/massage", label: "Massage" },
                { path: "/omoss", label: "Om oss" },
                { path: "/kontakt", label: "Kontakt" },
              ].map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={toggle}
                  className="block w-full text-center py-3 text-2xl font-bold text-gray-800 hover:bg-gray-100"
                >
                  {item.label}
                </Link>
              ))}
            </div>

            {/* Social Media Links */}
            <div className="absolute mt-16 bottom-6 flex justify-center w-full space-x-4 text-2xl">
              <a
                href="https://www.facebook.com/ladabasteskar"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-facebook transition"
              >
                <BsFacebook size={32} />
              </a>
              <a
                href="https://www.instagram.com/lada_basteskar?igsh=dThzbWluNXJ1Z2gw"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-instagram transition"
              >
                <BsInstagram size={32} />
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
